/**
 * Norm Tables for Assessment Leaderboards
 * 
 * Structure:
 * - Assessment title (must match LeaderboardCard title)
 *   - sex: "male" | "female"
 *     - age band: "6-9" | "10-11" | "12-13" | "13-14" | "15-16" | "17-18"
 *       - Array of { category, value }
 * 
 * Categories: "Developing", "On Track", "Advanced"
 */

const normTables = {
  // ============================================
  // 10 YARD SPRINT
  // ============================================
  "10 Yard Sprint": {
    female: {
      "6-9": [
        { category: "Developing", value: "≥2.40" },
        { category: "On Track", value: "2.21–2.39" },
        { category: "Advanced", value: "≤2.20" }
      ],
      "10-11": [
        { category: "Developing", value: "≥2.30" },
        { category: "On Track", value: "2.11–2.29" },
        { category: "Advanced", value: "≤2.10" }
      ],
      "12-13": [
        { category: "Developing", value: "≥2.14" },
        { category: "On Track", value: "1.95–2.13" },
        { category: "Advanced", value: "≤1.94" }
      ],
      "13-14": [
        { category: "Developing", value: "≥2.14" },
        { category: "On Track", value: "1.97–2.13" },
        { category: "Advanced", value: "≤1.96" }
      ],
      "15-16": [
        { category: "Developing", value: ">1.90" },
        { category: "On Track", value: "1.82–1.90" },
        { category: "Advanced", value: "<1.82" }
      ],
      "17-18": [
        { category: "Developing", value: ">1.90" },
        { category: "On Track", value: "1.82–1.90" },
        { category: "Advanced", value: "<1.82" }
      ]
    },
    male: {
      "6-9": [
        { category: "Developing", value: "≥2.24" },
        { category: "On Track", value: "2.09–2.23" },
        { category: "Advanced", value: "≤2.08" }
      ],
      "10-11": [
        { category: "Developing", value: "≥2.19" },
        { category: "On Track", value: "2.02–2.18" },
        { category: "Advanced", value: "≤2.01" }
      ],
      "12-13": [
        { category: "Developing", value: "≥2.02" },
        { category: "On Track", value: "1.87–2.01" },
        { category: "Advanced", value: "≤1.86" }
      ],
      "13-14": [
        { category: "Developing", value: "≥1.95" },
        { category: "On Track", value: "1.82–1.94" },
        { category: "Advanced", value: "≤1.81" }
      ],
      "15-16": [
        { category: "Developing", value: "≥1.70" },
        { category: "On Track", value: "1.61–1.69" },
        { category: "Advanced", value: "≤1.60" }
      ],
      "17-18": [
        { category: "Developing", value: "≥1.65" },
        { category: "On Track", value: "1.56–1.64" },
        { category: "Advanced", value: "≤1.55" }
      ]
    }
  },

  // ============================================
  // 10 YARD FLY
  // ============================================
  "10 Yard Fly": {
    female: {
      "6-9": [
        { category: "Developing", value: "≥2.30" },
        { category: "On Track", value: "2.11–2.29" },
        { category: "Advanced", value: "≤2.10" }
      ],
      "10-11": [
        { category: "Developing", value: "≥2.20" },
        { category: "On Track", value: "2.01–2.19" },
        { category: "Advanced", value: "≤2.00" }
      ],
      "12-13": [
        { category: "Developing", value: "≥2.04" },
        { category: "On Track", value: "1.85–2.03" },
        { category: "Advanced", value: "≤1.84" }
      ],
      "13-14": [
        { category: "Developing", value: "≥2.04" },
        { category: "On Track", value: "1.87–2.03" },
        { category: "Advanced", value: "≤1.86" }
      ],
      "15-16": [],
      "17-18": []
    },
    male: {
      "6-9": [
        { category: "Developing", value: "≥2.14" },
        { category: "On Track", value: "1.99–2.13" },
        { category: "Advanced", value: "≤1.98" }
      ],
      "10-11": [
        { category: "Developing", value: "≥2.09" },
        { category: "On Track", value: "1.92–2.08" },
        { category: "Advanced", value: "≤1.91" }
      ],
      "12-13": [
        { category: "Developing", value: "≥1.92" },
        { category: "On Track", value: "1.77–1.91" },
        { category: "Advanced", value: "≤1.76" }
      ],
      "13-14": [
        { category: "Developing", value: "≥1.85" },
        { category: "On Track", value: "1.72–1.84" },
        { category: "Advanced", value: "≤1.71" }
      ],
      "15-16": [
        { category: "Developing", value: "≥1.60" },
        { category: "On Track", value: "1.51–1.59" },
        { category: "Advanced", value: "≤1.50" }
      ],
      "17-18": [
        { category: "Developing", value: "≥1.55" },
        { category: "On Track", value: "1.46–1.54" },
        { category: "Advanced", value: "≤1.45" }
      ]
    }
  },

  // ============================================
  // BROAD JUMP
  // ============================================
  "Broad Jump": {
    female: {
      "6-9": [
        { category: "Developing", value: "≤41.2 in (105 cm)" },
        { category: "On Track", value: "41.3–55.6 in (105–141 cm)" },
        { category: "Advanced", value: "≥55.7 in (141 cm)" }
      ],
      "10-11": [
        { category: "Developing", value: "≤45.7 in (116 cm)" },
        { category: "On Track", value: "45.8–60.9 in (116–155 cm)" },
        { category: "Advanced", value: "≥60.9 in (155 cm)" }
      ],
      "12-13": [
        { category: "Developing", value: "≤50.9 in (129 cm)" },
        { category: "On Track", value: "51.0–67.8 in (129–172 cm)" },
        { category: "Advanced", value: "≥67.9 in (173 cm)" }
      ],
      "13-14": [
        { category: "Developing", value: "≤52.4 in (133 cm)" },
        { category: "On Track", value: "52.5–69.8 in (133–178 cm)" },
        { category: "Advanced", value: "≥69.9 in (178 cm)" }
      ],
      "15-16": [
        { category: "Developing", value: "≤52.8 in (134 cm)" },
        { category: "On Track", value: "52.9–70.2 in (134–179 cm)" },
        { category: "Advanced", value: "≥70.3 in (179 cm)" }
      ],
      "17-18": [
        { category: "Developing", value: "≤53.3 in (136 cm)" },
        { category: "On Track", value: "53.4–70.4 in (136–179 cm)" },
        { category: "Advanced", value: "≥70.5 in (179 cm)" }
      ]
    },
    male: {
      "6-9": [
        { category: "Developing", value: "≤45.1 in (115 cm)" },
        { category: "On Track", value: "45.2–58.0 in (115–147 cm)" },
        { category: "Advanced", value: "≥58.1 in (148 cm)" }
      ],
      "10-11": [
        { category: "Developing", value: "≤49.3 in (125 cm)" },
        { category: "On Track", value: "49.4–65.0 in (125–165 cm)" },
        { category: "Advanced", value: "≥65.0 in (165 cm)" }
      ],
      "12-13": [
        { category: "Developing", value: "≤56.7 in (144 cm)" },
        { category: "On Track", value: "56.8–74.2 in (144–189 cm)" },
        { category: "Advanced", value: "≥74.3 in (189 cm)" }
      ],
      "13-14": [
        { category: "Developing", value: "≤61.5 in (156 cm)" },
        { category: "On Track", value: "61.6–80.0 in (156–203 cm)" },
        { category: "Advanced", value: "≥80.1 in (203 cm)" }
      ],
      "15-16": [
        { category: "Developing", value: "≤68.7 in (175 cm)" },
        { category: "On Track", value: "68.8–88.3 in (175–225 cm)" },
        { category: "Advanced", value: "≥88.4 in (225 cm)" }
      ],
      "17-18": [
        { category: "Developing", value: "≤73.1 in (186 cm)" },
        { category: "On Track", value: "73.2–92.2 in (186–234 cm)" },
        { category: "Advanced", value: "≥92.3 in (234 cm)" }
      ]
    }
  },

  // ============================================
  // VERTICAL JUMP
  // ============================================
  "Vertical Jump": {
    female: {
      "6-9": [
        { category: "Developing", value: "≤5.7 in (14.6 cm)" },
        { category: "On Track", value: "5.8–7.7 in (14.6–19.7 cm)" },
        { category: "Advanced", value: "≥7.8 in (19.7 cm)" }
      ],
      "10-11": [
        { category: "Developing", value: "≤5.1 in (12.9 cm)" },
        { category: "On Track", value: "5.2–6.9 in (12.9–17.6 cm)" },
        { category: "Advanced", value: "≥6.9 in (17.6 cm)" }
      ],
      "12-13": [
        { category: "Developing", value: "≤6.0 in (15.2 cm)" },
        { category: "On Track", value: "6.0–8.0 in (15.2–20.3 cm)" },
        { category: "Advanced", value: "≥8.0 in (20.3 cm)" }
      ],
      "13-14": [
        { category: "Developing", value: "≤6.0 in (15.1 cm)" },
        { category: "On Track", value: "6.0–7.9 in (15.1–20.1 cm)" },
        { category: "Advanced", value: "≥7.9 in (20.1 cm)" }
      ],
      "15-16": [
        { category: "Developing", value: "≤5.9 in (15.0 cm)" },
        { category: "On Track", value: "5.9–8.1 in (15.0–20.6 cm)" },
        { category: "Advanced", value: "≥8.1 in (20.6 cm)" }
      ],
      "17-18": [
        { category: "Developing", value: "≤6.1 in (15.4 cm)" },
        { category: "On Track", value: "6.1–8.1 in (15.4–20.6 cm)" },
        { category: "Advanced", value: "≥8.1 in (20.6 cm)" }
      ]
    },
    male: {
      "6-9": [
        { category: "Developing", value: "≤6.1 in (15.6 cm)" },
        { category: "On Track", value: "6.2–8.4 in (15.6–21.4 cm)" },
        { category: "Advanced", value: "≥8.4 in (21.4 cm)" }
      ],
      "10-11": [
        { category: "Developing", value: "≤5.9 in (15.0 cm)" },
        { category: "On Track", value: "5.9–7.8 in (15.0–19.9 cm)" },
        { category: "Advanced", value: "≥7.8 in (19.9 cm)" }
      ],
      "12-13": [
        { category: "Developing", value: "≤7.3 in (18.4 cm)" },
        { category: "On Track", value: "7.3–9.6 in (18.4–24.5 cm)" },
        { category: "Advanced", value: "≥9.6 in (24.5 cm)" }
      ],
      "13-14": [
        { category: "Developing", value: "≤8.1 in (20.5 cm)" },
        { category: "On Track", value: "8.1–10.7 in (20.5–27.3 cm)" },
        { category: "Advanced", value: "≥10.8 in (27.3 cm)" }
      ],
      "15-16": [
        { category: "Developing", value: "≤8.8 in (22.3 cm)" },
        { category: "On Track", value: "8.8–12.3 in (22.3–31.3 cm)" },
        { category: "Advanced", value: "≥12.3 in (31.3 cm)" }
      ],
      "17-18": [
        { category: "Developing", value: "≤9.4 in (23.8 cm)" },
        { category: "On Track", value: "9.4–13.1 in (23.8–33.4 cm)" },
        { category: "Advanced", value: "≥13.1 in (33.4 cm)" }
      ]
    }
  }
};

// Age bands supported
export const AGE_BANDS = ["6-9", "10-11", "12-13", "13-14", "15-16", "17-18"];

/**
 * Get the age band for a given age
 * @param {number} age - The athlete's age
 * @returns {string|null} - The age band or null if not in any band
 */
export const getAgeBand = (age) => {
  if (age >= 6 && age <= 9) return "6-9";
  if (age >= 10 && age <= 11) return "10-11";
  if (age >= 12 && age <= 13) return "12-13";
  if (age >= 13 && age <= 14) return "13-14";
  if (age >= 15 && age <= 16) return "15-16";
  if (age >= 17 && age <= 18) return "17-18";
  return null;
};

/**
 * Get norm table for a specific assessment, sex, and age
 * @param {string} assessmentTitle - The title of the assessment
 * @param {string} sex - "male" or "female"
 * @param {number} age - The athlete's age
 * @returns {Array|null} - Array of norm entries or null if no norms exist
 */
export const getNormTable = (assessmentTitle, sex, age) => {
  const assessment = normTables[assessmentTitle];
  if (!assessment) return null;
  
  const sexData = assessment[sex];
  if (!sexData) return null;
  
  const ageBand = getAgeBand(age);
  if (!ageBand) return null;
  
  const norms = sexData[ageBand];
  if (!norms || norms.length === 0) return null;
  
  return norms;
};

/**
 * Check if an assessment has norm data for a specific sex and age
 * @param {string} assessmentTitle - The title of the assessment
 * @param {string} sex - "male" or "female"
 * @param {number} age - The athlete's age
 * @returns {boolean} - True if norm data exists
 */
export const hasNormTable = (assessmentTitle, sex, age) => {
  const norms = getNormTable(assessmentTitle, sex, age);
  return norms !== null && norms.length > 0;
};

/**
 * Check if an assessment has any norm data at all (for any sex/age)
 * @param {string} assessmentTitle - The title of the assessment
 * @returns {boolean} - True if any norm data exists
 */
export const hasAnyNormData = (assessmentTitle) => {
  return normTables[assessmentTitle] !== undefined;
};

export default normTables;
